import { ChannelConfig } from "app/types/Channels";
import { indexBy } from "../../utils/Arrays";

const RAW_CHANNELS: ChannelConfig[] = [
    {
        channelId: "us",
        apiId: "US_DIGITAL_LIVE",
        displayName: "US_TV_PHOENIX",
        liveId: "PHOENIX_US",
        isTVStream: true,
        isEventChannel: false,
        scheduleName: "U.S. Schedule",
        selectable: true,
        coJPOverrides: {
            selectable: false,
        },
    },
    {
        channelId: "us/btv",
        apiId: "US_DIGITAL_LIVE",
        displayName: "US_BTV",
        liveId: "US",
        isTVStream: true,
        isEventChannel: false,
        scheduleName: "U.S. Schedule",
        selectable: true,
        scheduleLink: "us",
        coJPOverrides: {
            channelId: "us",
            liveId: "PHOENIX_JAPAN",
            displayName: "US_TV",
        },
        excludeInCountries: ["CA"],
    },
    {
        channelId: "europe",
        apiId: "PAN_EUROPE",
        displayName: "EUROPE_TV",
        liveId: "EU",
        isTVStream: true,
        isEventChannel: false,
        scheduleName: "European Schedule",
        selectable: true,
        excludeInCountries: ["CA"],
    },
    {
        channelId: "asia",
        apiId: "ASIA",
        displayName: "ASIA_TV",
        liveId: "ASIA",
        isTVStream: true,
        isEventChannel: false,
        scheduleName: "Asia Schedule",
        selectable: true,
        excludeInCountries: ["CA"],
    },
    {
        channelId: "australia",
        apiId: "AUSTRALIA",
        displayName: "AUS_TV",
        liveId: "AUS",
        isTVStream: true,
        isEventChannel: false,
        scheduleName: "Australian Schedule",
        selectable: true,
        excludeInCountries: ["CA"],
    },
    {
        channelId: "stream",
        apiId: "US_LIVE_EVENT_API_ID",
        displayName: "US_LIVE_EVENT",
        liveId: "EVENT",
        isTVStream: true,
        isEventChannel: true,
        selectable: true,
    },
    {
        channelId: "emea",
        apiId: "EMEA_LIVE_EVENT_API_ID",
        displayName: "EMEA_LIVE_EVENT",
        liveId: "EMEA_EVENT",
        isTVStream: true,
        isEventChannel: true,
        selectable: true,
    },
    {
        channelId: "asia_stream",
        apiId: "ASIA_LIVE_EVENT_API_ID",
        displayName: "ASIA_LIVE_EVENT",
        liveId: "ASIA_EVENT",
        isTVStream: true,
        isEventChannel: true,
        selectable: true,
    },
    {
        channelId: "politics",
        apiId: "POLITICS_LIVE_EVENT_API_ID",
        displayName: "POLITICS_LIVE_EVENT",
        liveId: "POLITICS",
        isTVStream: true,
        isEventChannel: true,
        selectable: true,
    },
    {
        channelId: "national",
        apiId: "WBBR_RADIO",
        liveId: "RADIO",
        displayName: "NATIONAL_RADIO",
        isTVStream: false,
        isEventChannel: false,
        selectable: true,
        adPath: "",
    },
    {
        channelId: "newyork",
        liveId: "RADIO_NY",
        apiId: "WBBR_RADIO",
        displayName: "NEW_YORK_RADIO",
        isTVStream: false,
        isEventChannel: false,
        selectable: true,
        adPath: "newyork",
    },
    {
        channelId: "boston",
        apiId: "BOSTON_RADIO",
        liveId: "RADIO_BOS",
        displayName: "BOSTON_RADIO",
        isTVStream: false,
        isEventChannel: false,
        selectable: true,
        adPath: "boston",
    },
    {
        channelId: "dc",
        liveId: "RADIO_DC",
        apiId: "WASHINGTON_DC_RADIO",
        displayName: "WASHINGTON_DC_RADIO",
        isTVStream: false,
        isEventChannel: false,
        selectable: true,
        adPath: "dc",
    },
];

const DEFAULT_SCHEDULE_CHANNEL_ID = "us";
const COJP_DEFAULT_SCHEDULE_CHANNEL_ID = "asia";
const AUDIO_CHANNELS = RAW_CHANNELS.filter((channel) => !channel.isTVStream);
const RADIO_CHANNEL_PREFERENCE_KEY = "bb::audio::radio::station";

export const channelsById = indexBy(RAW_CHANNELS, ({ channelId }) => channelId);

export {
    DEFAULT_SCHEDULE_CHANNEL_ID,
    COJP_DEFAULT_SCHEDULE_CHANNEL_ID,
    AUDIO_CHANNELS,
    RAW_CHANNELS,
    RADIO_CHANNEL_PREFERENCE_KEY,
};
